module.exports = __webpack_public_path__ + "static/img/dang_objective.2a007117.jpg";